<style lang="less">
//@import '../styles/menu.less';
</style>
<template>
    <Menu ref="sideMenu"
        :active-name="$route.name"
        :open-names="openNames"
        :theme="menuTheme"
        width="auto"
        :accordion="accordion"
        @on-select="changeMenu"
    >
        <template v-for="item in menuList">
            <MenuItem v-if="!(item.children && item.children.length>0)" 
                    :name="item.children[0].name" 
                    :key="'menuitem' + item.name">
                <Icon :type="item.children[0].icon || item.icon" 
                    :size="iconSize" 
                    :key="'menuicon' + item.name"></Icon>
                <span class="layout-text" :key="'title' + item.name">{{ itemTitle(item.children[0]) }}</span>
            </MenuItem>
            <Submenu v-else :name="item.name" :key="item.name">
                <template slot="title">
                    <Icon :type="item.icon" :size="iconSize"></Icon>
                    <span class="layout-text" @click="changeMenu(item.name)">{{ itemTitle(item) }}</span>
                </template>
                <template v-for="child in item.children">
                    <MenuItem :name="child.name" :key="'menuitem' + child.name" class="menu-title">
                        <Icon :type="child.icon" :size="iconSize" :key="'icon' + child.name"></Icon>
                        <span class="layout-text" :key="'title' + child.name">{{ itemTitle(child) }}</span>
                    </MenuItem>
                </template>
            </Submenu>
        </template>
    </Menu>
</template>

<script>
export default {
    name: "sidebarMenu",
    props: {
        menuList: Array,
        iconSize: Number,
        menuTheme: {
            type: String,
            default: "light"
        },
        openNames: {
            type: Array
        },
        accordion:{
            type:Boolean,
            default:false
        }
    },
    methods: {
        changeMenu(name) {
            console.log(name)
            if(name === 'transcoding'){
                name = 'transcodingTaskEdit'
            }else if(name==='cutout'){
                name = 'cutoutEdit'
            }
            this.$router.push({
                name
            });
            this.$emit("on-change", name);
        },
        itemTitle(item) {
          if(item.title){
            if (typeof item.title === "object") {
              return this.$t(item.title.i18n);
            } else {
              return item.title;
            }
          }else if(item.meta&&item.meta.title){
            return this.itemTitle(item.meta)
          }
        }
    },
    updated() {
        this.$nextTick(() => {
            if (this.$refs.sideMenu) {
                this.$refs.sideMenu.updateOpened();
            }
        });
    }
};
</script>
